import axios from "axios";
import { getCookie, setCookie, deleteCookie } from "../utils/cookie";
import apiRoutes from "../api/api_route";

export const clearAuthCookies = () => {
  [
    "accessToken",
    "refreshToken",
    "accessExpiresIn",
    "refreshExpiresIn",
  ].forEach(deleteCookie);
};

export const resetDataAndLogout = () => {
  clearAuthCookies();
  window.location.href = "/";
};

export const setLoginCookies = (data) => {
  const accessSec = data.accessExpiresIn || 1800;
  const refreshSec = data.refreshExpiresIn || 2400;
  setCookie("accessToken", data.accessToken || data.token, accessSec / 86400);
  setCookie("refreshToken", data.refreshToken, refreshSec / 86400);
  setCookie("accessExpiresIn", String(accessSec), accessSec / 86400);
  setCookie("refreshExpiresIn", String(refreshSec), refreshSec / 86400);
};

let refreshPromise = null;

export const getRefreshToken = () => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = (async () => {
    try {
      const token = getCookie("refreshToken");
      if (!token) return null;

      const res = await axios.post(
        apiRoutes.auth.refreshToken,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data?.accessToken || res.data?.token) {
        setLoginCookies(res.data);
        return res.data.accessToken || res.data.token;
      }

      return null;
    } catch (err) {
      console.error(
        "Refresh token failed:",
        err.response?.status,
        err.response?.data || err.message,
      );
      return null;
    }
  })();

  refreshPromise.finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
};
